import { motion } from "framer-motion";
import {
  Users,
  GitBranch,
  ShoppingCart,
  FileText,
  FileSignature,
  FolderOpen,
  CreditCard,
  CalendarCheck,
  UserCog,
  ShieldCheck,
  Bell,
  LayoutDashboard,
  BarChart3,
  Zap,
  Sparkles,
  Plug,
  Boxes,
} from "lucide-react";
import { SectionHeading, fadeUp } from "@/components/landing/shared";
import { useSiteContent } from "@/context/ContentContext";

const ICONS = [
  Users, Boxes, GitBranch, ShoppingCart, FileText, FileSignature, FolderOpen,
  CreditCard, CalendarCheck, UserCog, ShieldCheck, Bell, LayoutDashboard,
  BarChart3, Zap, Sparkles, Plug, Plug,
];

export default function CentralizeSection() {
  const { centralize } = useSiteContent();
  const areas = centralize.areas || [];
  return (
    <section
      id="centralizzare"
      className="relative scroll-mt-20 border-t border-black/[0.08] py-16 md:py-24 lg:py-28"
    >
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={centralize.eyebrow}
          title={centralize.title}
          intro={centralize.intro}
        />

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {areas.map((label, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={`${label}-${i}`}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-30px" }}
                variants={fadeUp}
                custom={i % 6}
                className="group flex flex-col items-start gap-3 rounded-xl border border-black/10 bg-white p-4 transition-colors duration-200 hover:border-emerald-400/30 hover:bg-emerald-600/[0.04]"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-black/10 bg-white text-secondary transition-colors duration-200 group-hover:text-emerald-700">
                  <Icon className="h-4 w-4" />
                </span>
                <span className="text-sm font-medium text-[color:var(--text-primary)]">
                  {label}
                </span>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          variants={fadeUp}
          className="mt-10 rounded-xl border border-emerald-400/20 bg-emerald-600/[0.05] px-5 py-4"
        >
          <p className="text-sm leading-relaxed text-[color:var(--text-primary)] md:text-base">
            <span className="font-semibold">{centralize.note_bold}</span>{" "}
            {centralize.note}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
